import { API } from 'aws-amplify';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Logger } from '@meprism/app-utils';
import { Toast } from '../../components/toast/toast';
import { useAppSelector } from '../storeExports';
import { BillingSlice, InvoiceOverview } from './CorporateBillingTypes';

const initialState: BillingSlice = {
  overview: null,
  loading: false
};

const fetchBillingOverviewApi = async (code: string): Promise<InvoiceOverview> => {
    return API.get('CorpOnboarding', `/corp/invoice/${code}`, {});
};


export const fetchBillingOverview = createAsyncThunk(
  'billing/fetchOverview',
  async (code: string, { rejectWithValue }) => {
    try {
      return await fetchBillingOverviewApi(code);
    } catch (error: any) {
      Logger.error(`Error fetching billing overview: ${error}`);
      Toast.show({
        type: 'error',
        text1: 'Could not fetch billing overview',
      });
      return rejectWithValue(error.message ?? 'Unknown error');
    }
  }
);



const billingSlice = createSlice({
  name: 'billing',
  initialState,
  reducers: {
    clearBillingOverview: (state) => {
      state.overview = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBillingOverview.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBillingOverview.fulfilled, (state, action: PayloadAction<InvoiceOverview>) => {
        state.overview = action.payload;
         state.loading = false;
      })
      .addCase(fetchBillingOverview.rejected, (state) => {
        state.loading = false;
      });
  },
});


export const { clearBillingOverview } = billingSlice.actions;
export const BillingReducer = billingSlice.reducer;

export const BillingOverviewSelector = () =>
  useAppSelector((state) => ({
    overview: state.corporateBilling.overview,
    loading: state.corporateBilling.loading,
  }));